var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#ECFDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.01 26.6666H14.4157C14.2619 26.6666 14.1144 26.6055 14.0057 26.4968C13.897 26.3881 13.8359 26.2406 13.8359 26.0869C13.8359 25.9331 13.897 25.7857 14.0057 25.6769C14.1144 25.5682 14.2619 25.5072 14.4157 25.5072H26.01C26.1637 25.5072 26.3112 25.5682 26.4199 25.6769C26.5286 25.7857 26.5897 25.9331 26.5897 26.0869C26.5897 26.2406 26.5286 26.3881 26.4199 26.4968C26.3112 26.6055 26.1637 26.6666 26.01 26.6666Z",
    fill: "#039855"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5525 15.652L15.7449 20.4596C15.6706 20.5339 15.6179 20.6271 15.5925 20.7291L14.4157 24.3477L18.0342 23.1709C18.1363 23.1455 18.2294 23.0928 18.3038 23.0184L23.1114 18.2109L20.5525 15.652Z",
    fill: "#039855"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2604 15.2421L23.5212 13.503C23.4125 13.3943 23.2651 13.3333 23.1114 13.3333C22.9577 13.3333 22.8102 13.3943 22.7015 13.503L21.3722 14.8323L23.9311 17.3911L25.2604 16.0618C25.3691 15.9531 25.4301 15.8057 25.4301 15.652C25.4301 15.4983 25.3691 15.3508 25.2604 15.2421Z",
    fill: "#039855"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.a2494e2e6e5096f803e3e582a0692816.svg";
export { ForwardRef as ReactComponent };